import { NgModule, APP_INITIALIZER, Injector, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';

import { AppComponent } from './app.component';

import { AuthInterceptor } from '@shared/interceptors/auth.interceptor';
import { StatusInterceptor } from '@shared/interceptors/status.interceptor';
import { PreInitService, preInitServiceFactory } from '@core/services/pre-init.service';

import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';

import { AppRoutingModule } from './app-routing.module';
import { environment } from '@env/environment';
import { CoreModule } from '@core/core.module';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';

const isIE = window.navigator.userAgent.indexOf('MSIE') > -1 
    || window.navigator.userAgent.indexOf('Trident/') > -1;

registerLocaleData(localeNl);

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [
        AppComponent,
        MsalRedirectComponent
    ], 
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NgHttpLoaderModule.forRoot(),
        CoreModule,
        LoggerModule.forRoot({ level: NgxLoggerLevel.DEBUG }),
        FontAwesomeModule,
        MsalModule.forRoot(new PublicClientApplication({
            auth: {
                clientId: environment.clientId,
                redirectUri: environment.msalRedirectUri,
                authority: environment.authority,
                postLogoutRedirectUri: environment.msalPostLogoutRedirectUri
            },
            cache: {
                cacheLocation: environment.localStorage,
                storeAuthStateInCookie: isIE
            },
            system: {
                allowNativeBroker: false,
            }
            }),
            {
                interactionType: InteractionType.Redirect,
                authRequest: {
                    scopes: environment.scopes
                }
            },
            {
                interactionType: InteractionType.Redirect,
                protectedResourceMap: new Map(
                    [
                        [
                            environment.graphUri,
                            environment.scopes
                        ]
                    ]
                )
            }
        )
    ],
    providers: [
        {
            provide: LOCALE_ID,
            useValue: "nl-NL"
        },
        PreInitService,
        {
            provide: APP_INITIALIZER,
            useFactory: preInitServiceFactory,
            multi: true,
            deps: [PreInitService, Injector],
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: StatusInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        MsalGuard,
        MsalService,
        MsalBroadcastService,
        environment.providers,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
